import { WEBVIEW_TYPES } from '@/lib/consts'
import AndroidIdentity from './android-identity'
import IOSIdentity from './ios-identity'
import DeviceIdentity from './device-identity'

export const TOKEN_ACTIONS = {
  REGISTER: 'registerToken',
  CLEAR: 'clearToken',
}

export const DEVICE_CLASSES: Record<string, typeof DeviceIdentity> = {
  [WEBVIEW_TYPES.ANDROID]: AndroidIdentity,
  [WEBVIEW_TYPES.IOS]: IOSIdentity,
}
